var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Fragment, forwardRef } from "react";
import Drop from "../drop";
import useForwardRef from "../../../hooks/use-forward-ref";
import useToggle from "../../../hooks/use-toggle";
import useClonedChildren from "../mixins/useClonedChildren";
import useDescribedId from "../mixins/useDescribedId";
import dropAlignMap from "../mixins/dropAlignMap";
import Container from "../container";
var getContent = function (content) { return (typeof content === "function" ? content() : content); };
var Tooltip = forwardRef(function (_a, parentRef) {
    var plain = _a.plain, _b = _a.open, initialOpen = _b === void 0 ? false : _b, _c = _a.align, align = _c === void 0 ? "top" : _c, dropProps = _a.dropProps, content = _a.content, animation = _a.animation, children = _a.children, rest = __rest(_a, ["plain", "open", "align", "dropProps", "content", "animation", "children"]);
    var id = useDescribedId(rest["aria-describedby"]);
    var _d = useToggle(initialOpen), isOpen = _d[0], open = _d[2], close = _d[3];
    var _e = useForwardRef(parentRef), ref = _e[0], setRef = _e[1];
    var targetElement = useClonedChildren(children, setRef, __assign(__assign({ onMouseOver: open, onMouseLeave: close, onFocus: open, onBlur: close }, (isOpen && { "aria-describedby": id })), rest));
    return (React.createElement(Fragment, null,
        targetElement,
        isOpen && ref.current && (React.createElement(Drop, __assign({ target: ref.current, id: id }, dropProps, { align: (dropProps === null || dropProps === void 0 ? void 0 : dropProps.align) || dropAlignMap[align], onEsc: close, animation: animation }), plain ? (getContent(content)) : (React.createElement(Container, { align: align }, getContent(content)))))));
});
export default Tooltip;
